import { router, useLocalSearchParams } from 'expo-router';
import * as React from 'react';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    FullScreenSpinner,
    ScreenContainer,
    YStack,
} from 'smoothie';

import { captureException } from '../../../logger/Logger';
import useGetCardWidgetUrl from '../../hooks/card/useGetCardWidgetUrl';
import useGetAllBankAccountDetails from '../../hooks/useGetAllBankAccountDetails';
import { CardWidgetType } from '../../types/Card';
import CardWidget from './CardWidget';

const ActivateCard = () => {
    const { syncteraAccountId, cardId } = useLocalSearchParams<{
        syncteraAccountId: string;
        cardId: string;
    }>();

    const { data, isLoading } = useGetCardWidgetUrl({
        syncteraAccountId,
        cardId,
        widgetType: CardWidgetType.ACTIVATE_CARD,
    });

    const { refetchAccountDetails } = useGetAllBankAccountDetails(false);

    if (isLoading) return <FullScreenSpinner />;

    if (data?.url == null) {
        captureException(new Error('Failed to fetch activate card widget url'));
        router.back();
        return <></>;
    }

    return (
        <ScreenContainer title="Activate card" hasBackButton>
            <YStack
                justifyContent="space-between"
                $sm={{ alignItems: 'center' }}
            >
                <CardWidget url={data.url} />
                <Button
                    // This button is a temporary workaround until (if) we can show a custom success page at the end of the activation widget
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Done"
                    onPress={() => {
                        void refetchAccountDetails();
                        router.back();
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
};

export default ActivateCard;
